namespace TabAurous.ECommerce {
    export namespace OrderManagementCheckListService {
        export const baseUrl = 'ECommerce/OrderManagementCheckList';

        export declare function Create(request: Serenity.SaveRequest<OrderManagementCheckListRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderManagementCheckListRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderManagementCheckListRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderManagementCheckListRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/OrderManagementCheckList/Create",
            Update = "ECommerce/OrderManagementCheckList/Update",
            Delete = "ECommerce/OrderManagementCheckList/Delete",
            Retrieve = "ECommerce/OrderManagementCheckList/Retrieve",
            List = "ECommerce/OrderManagementCheckList/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrderManagementCheckListService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
